module.exports = __webpack_public_path__ + "static/img/Risk260112EN.acddc75.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Risk260112EN.jpg
// module id = pdtO
// module chunks = 1